import React from 'react';
import './App.css';
import { Navigation, Footer } from './components/redesign/Navigation';
import { PlayfulHero, PlayfulCTA } from './components/redesign/PlayfulHero';
import { ProblemStatements } from './components/redesign/ProblemStatements';
import { TransformationNarrative } from './components/redesign/TransformationNarrative';
import { Offerings } from './components/redesign/Offerings';
import { WhatToExpect } from './components/redesign/WhatToExpect';
import { About } from './components/redesign/About';
import { Testimonials } from './components/redesign/Testimonials';

function App() {
  return (
    <div className="App">
      <Navigation />
      
      <main className="pt-20">
        <section id="home">
          <PlayfulHero />
        </section>

        <ProblemStatements />
        
        <PlayfulCTA className="bg-[#E8F5F4]" />

        <TransformationNarrative />
        
        <PlayfulCTA className="bg-[#FFF9F0]" />

        <section id="offerings">
          <Offerings />
        </section>
        
        <PlayfulCTA className="bg-[#FFF3E0]" />

        <WhatToExpect />
        
        <PlayfulCTA className="bg-[#F5E8F7]" />

        <section id="about">
          <About />
        </section>
        
        <PlayfulCTA className="bg-[#E8F5F4]" />

        <section id="testimonials">
          <Testimonials />
        </section>
        
        <PlayfulCTA className="bg-[#FFF9F0]" />
      </main>

      <Footer />
    </div>
  );
}

export default App;
